try {
    window.$=window.jQuery=require('jquery');
    window.bootstrap=require('bootstrap/dist/js/bootstrap.bundle');
    window.flatpickr=require('flatpickr/dist/flatpickr');
    window.select2 = require('select2')
} catch (e) {}
